export const TOOL_PREP_DOWNLOAD_FORMATS = [
  {
    id: "png",
    label: "PNG",
    mime: "image/png",
    extension: "png",
    supportsTransparency: true,
    description: "Best quality · keeps transparency",
  },
  {
    id: "jpg",
    label: "JPG",
    mime: "image/jpeg",
    extension: "jpg",
    supportsTransparency: false,
    description: "Smaller file · no transparency",
  },
  {
    id: "webp",
    label: "WebP",
    mime: "image/webp",
    extension: "webp",
    supportsTransparency: true,
    description: "Smallest file · keeps transparency",
  },
];

export const PASSPORT_DELIVERABLE_OPTIONS = [
  {
    id: "digital",
    label: "Digital only",
    description: "Single passport photo file",
  },
  {
    id: "digital_print",
    label: "Digital + Print sheet",
    description: "Photo file plus a print-ready PDF sheet",
  },
];

export function getDownloadFormat(id = "png") {
  return (
    TOOL_PREP_DOWNLOAD_FORMATS.find((f) => f.id === id) ||
    TOOL_PREP_DOWNLOAD_FORMATS[0]
  );
}

export function stripDownloadFileBaseName(name, fallback = "image") {
  if (!name || typeof name !== "string") return fallback;
  const base = name.trim().replace(/\.[^.]+$/, "");
  return base || fallback;
}

export function buildDownloadFileName(baseName, formatId) {
  const fmt = getDownloadFormat(formatId);
  const base = stripDownloadFileBaseName(baseName, "image");
  return `${base}.${fmt.extension}`;
}
